export default __webpack_public_path__ + "static/media/angry.13956aa7.svg";